"use client"

import Link from "next/link";
import styles from "../../styles/Pages/RidesAndActivities.module.scss";
import Image from "next/image";
import { RidesAndActivitiesData } from "../../data/RidesAndActivitiesData";
import Topbanner from "../../components/Reusable/Banner/Topbanner";
import { useEffect, useState } from "react";
import { AncorPrimaryButton, AncorTernaryButton } from "../../components/Reusable/Buttons/Buttons";

// export const getStaticProps = async () => {
//   return {
//     props: {
//       Allattractions: RidesAndActivitiesData,
//     },
//   };
// };

const SkeletonLoader = () => {
  return (
    <div className={`${styles.attraction_child} common_title col-md-4`}>
      <div className={`${styles.skeleton_image_wrapper} ${styles.skeleton}`}></div>
      <h3 className={`${styles.skeleton_heading} ${styles.skeleton}`}></h3>
      <p className={`${styles.skeleton_title} ${styles.skeleton}`}></p>
      <div className={styles.skelton_btn_parent}>
        <span className={`${styles.skeleton_btn} ${styles.skeleton}`}></span>
        <span className={`${styles.skeleton_btn} ${styles.skeleton}`}></span>
      </div>
    </div>
  );
};

export default function RidesAndActivities() {
  const Allattractions = RidesAndActivitiesData;
  const [visible, setVisible] = useState(9);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 4000);
    return () => clearTimeout(timer);
  }, []);

  const showMoreItems = () => {
    setVisible((prevValue) => prevValue + 6);
  };

  return (
    <>
      <Topbanner
        title={"Book Your Adventure Activities Now"}
        bgImage={"/images/rides-activities-banner.png"}
        target="#firstsec"
      />
      <section
        className={`${styles.all_attractions} common_padding`}
        id="firstsec"
      >
        {/* .slice(0, visible) */}

        <div className="container">
          <div className="row">
            {loading
              ? [...Array(9)].map((_, index) => (
                <SkeletonLoader key={index} />
              ))
              :
              Allattractions?.map((attraction) => (
                  <div
                    className={`${styles.attraction_child} common_title col-md-4`}
                    key={attraction.slug}
                  >
                    <div className={styles.image_wrapper}>
                      <Image
                        src={attraction.bgImage}
                        className="wrapimage"
                        alt={attraction.title}
                        width={412}
                        height={328}
                      ></Image>
                    </div>
                    <h3>{attraction.title}</h3>
                    <p>{attraction.description}</p>
                    <div className='d_flex flex_gap_10'>
                      <AncorPrimaryButton
                        redirectPage={'/tickets'}
                        className={'margin_0_auto w-50'}
                        buttonText={'Buy Tickets'}
                      />
                      {attraction.slug === "museum-of-mystique" ? (
                        <AncorTernaryButton
                          redirectPage={`/${attraction.slug}`}
                          className={'margin_0_auto w-50'}
                          buttonText={'View More'}
                        />
                      ) : (
                        <AncorTernaryButton
                          redirectPage={`/rides-and-activities/${attraction.slug}`}
                          className={'margin_0_auto w-50'}
                          buttonText={'View More'}
                        />
                      )}
                    </div>
                  </div>
                ))}

            {/* {Allattractions.slice(0, visible).map((attraction) => (
              <div
                className={`${styles.attraction_child} common_title col-md-4`}
                key={attraction.slug}
              >
                <div className={styles.image_wrapper}>
                  <Image
                    src={attraction.bgImage}
                    className="wrapimage"
                    alt={attraction.title}
                    width={412}
                    height={328}
                  ></Image>
                </div>
                <h3>{attraction.title}</h3>
                <p>{attraction.description}</p>
                <div className='d_flex flex_gap_10'>
                  <AncorPrimaryButton
                    redirectPage={'/tickets'}
                    className={'margin_0_auto w-50'}
                    buttonText={'Buy Tickets'}
                  />
                  <AncorTernaryButton
                    redirectPage={`/rides-and-activities/${attraction.slug}`}
                    className={'margin_0_auto w-50'}
                    buttonText={'View More'}
                  />
                </div>
              </div>
            ))} */}
          </div>


          {/* {visible !== 21 ? (
            <button onClick={showMoreItems} className="common_btn m-auto">
              Load More
            </button>
          ) : (
            ""
          )} */}
        </div>
      </section>
    </>
  );
}
